// extracted by mini-css-extract-plugin
export var dataCell = "_jn-2";
export var dataRow = "_jn-0";
export var headerRow = "_jn-1";